import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { oAuthQuery } from '@/features/PolicyRegistration/api';
import { usePolicyStore } from '@/entities/Policy/model/store';
import { formatDateToDDMMYYYY, getValidateDateFormat, localDate } from '@/shared/lib/utils/auxiliaryFuncitions';
import { useCoastCalculationStore } from '@/entities/CoastCalculation/model/store/useCoastCalculationStore';

export const useOAuth = () => {
    const navigate = useNavigate();
    const { setForm, setSecondForm, setId, setPolicyProcess, setCalculated, setPrice, setIsSuccess } = usePolicyStore();
    const { setIsPartner, setBankIsDisabled } = useCoastCalculationStore();

    return useMutation({
        mutationFn: oAuthQuery,
        onSuccess: ({ data }) => {
            const {
                actualAddress,
                email,
                lastName,
                firstName,
                passport,
                patronymic,
                placeOfBirth,
                phone,
                postAddress,
                cachedUser,
                tempPolicyUser,
            } = data;

            const secondFormData = {
                partnerId: cachedUser?.partner.id || '',
                hasDisease: cachedUser?.hasDisease === true ? 'Yes' : 'No',
                debt: cachedUser?.debt?.toString() || '',
                gender: cachedUser?.gender || '',
                disabilityGroup: cachedUser?.disabilityGroup.toString(),
                birthDate: data.birthDate ? formatDateToDDMMYYYY(cachedUser.birthDate) : '',
                policyStartDate: cachedUser?.policyStartDate
                    ? getValidateDateFormat(localDate(cachedUser?.policyStartDate) as string)
                    : '',

                firstName: firstName || tempPolicyUser?.firstName || '',
                lastName: lastName || tempPolicyUser?.lastName || '',
                email: email?.toLowerCase() || tempPolicyUser?.email || '',
                patronymic: patronymic || tempPolicyUser?.patronymic || '',
                placeOfBirth: placeOfBirth || tempPolicyUser?.placeOfBirth || '',
                phone:
                    phone?.replace(/\s+/g, '').replace(/^\+?7\(?(\d{3})\)?(\d{3})(\d{2})(\d{2})$/, '+7 ($1) $2-$3-$4') ||
                    tempPolicyUser?.phone
                        ?.replace(/\s+/g, '')
                        .replace(/^\+?7\(?(\d{3})\)?(\d{3})(\d{2})(\d{2})$/, '+7 ($1) $2-$3-$4') ||
                    '',

                serial: passport?.serial.replace(' ', '') || tempPolicyUser?.serial || '',
                number: passport?.number || tempPolicyUser?.number || '',
                dateIssued:
                    // eslint-disable-next-line no-nested-ternary
                    passport && passport?.dateIssued
                        ? getValidateDateFormat(localDate(passport?.dateIssued) as string)
                        : tempPolicyUser?.dateIssued
                          ? getValidateDateFormat(localDate(tempPolicyUser?.dateIssued) as string)
                          : '',
                issuerCode:
                    passport?.issuerCode.replace(/-/g, '').replace(/^(\d{3})(\d{3})$/, '$1-$2') ||
                    tempPolicyUser?.issuerCode ||
                    '',
                issuedBy: passport?.issuedBy || tempPolicyUser?.issuedBy || '',

                actualAdress: actualAddress?.fullAddress || tempPolicyUser?.factFullAddress || '',
                residenceAdress: data.addresses ? data.addresses[0].fullAddress : '',
                // eslint-disable-next-line no-nested-ternary
                credit: tempPolicyUser?.mortgage === null ? undefined : tempPolicyUser?.mortgage === true ? 'have' : 'getting',
                creditNumber: tempPolicyUser?.contractNumber || '',
                creditDate: tempPolicyUser?.creditDate
                    ? getValidateDateFormat(localDate(tempPolicyUser?.creditDate) as string)
                    : '',
                noPatronymic: false,
            };

            const formData = {
                partnerId: cachedUser.partner.id || '',
                hasDisease: cachedUser?.hasDisease === true ? 'Yes' : 'No',
                debt: cachedUser?.debt.toString() || '',
                disabilityGroup: cachedUser?.disabilityGroup.toString(),
                gender: cachedUser?.gender || '',
                policyStartDate: cachedUser?.policyStartDate
                    ? getValidateDateFormat(localDate(cachedUser?.policyStartDate) as string)
                    : '',
                birthDate: cachedUser?.birthDate ? formatDateToDDMMYYYY(cachedUser.birthDate) : '',
                rate: cachedUser?.rate,
                rateRaising: cachedUser?.rateRaising,
            };

            setIsSuccess(true);
            setPolicyProcess('PolicyRegistration');
            setForm(formData);
            setSecondForm(secondFormData);
            setId(cachedUser?.id);
            setPrice(cachedUser?.calculation.toString());
            setBankIsDisabled(cachedUser.isPartnerLink);
            setCalculated(true);
            setIsPartner(true);
            navigate('/');
        },
        onError: (error) => {
            console.log('useOAuthError', error);
            navigate('/');
        },
    });
};
